import React, { useCallback, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Controls from "../form/controls/Controls";
function Popup(props) {
  const { title, children, openPopup, setOpenPopup, ...other } = props;
  const handleEscKey = useCallback(
    (event) => {
      if (event.key === "Escape") {
        setOpenPopup(false);
      }
    },
    [setOpenPopup]
  );
  useEffect(() => {
    document.addEventListener("keyup", handleEscKey, false);

    // * Cleanup function
    return () => {
      document.removeEventListener("keyup", handleEscKey, false);
    };
  }, [handleEscKey]);
  return (
    <Dialog open={openPopup} maxWidth="md" {...other}>
      <DialogTitle>
        <div style={{ display: "flex" }}>
          <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
            {title}
          </Typography>
          <Controls.ActionButton
            color="secondary"
            onClick={() => {
              setOpenPopup(false);
            }}
          >
            <CloseIcon />
          </Controls.ActionButton>
        </div>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
    </Dialog>
  );
}

export default Popup;
